(function () {
  function parseCardNumber(value) {
    if (!value) {
      return Number.MAX_SAFE_INTEGER;
    }

    var text = String(value).trim().toLowerCase();
    var match = text.match(/\d+/);

    if (!match) {
      return Number.MAX_SAFE_INTEGER;
    }

    return parseInt(match[0], 10);
  }

  function setupBinderResultsControls() {
    var sortSelect = document.querySelector("[data-binder-sort]");
    var stockToggle = document.querySelector("[data-hide-out-of-stock]");
    var grid = document.querySelector("[data-binder-results-grid]");

    if (!grid || grid.dataset.resultsControlsReady === "true") {
      return;
    }

    grid.dataset.resultsControlsReady = "true";

    function getCards() {
      return Array.prototype.slice.call(grid.querySelectorAll("[data-binder-result-card]"));
    }

    function applyStockFilter() {
      var hideOutOfStock = stockToggle ? stockToggle.checked : false;

      getCards().forEach(function (card) {
        var isAvailable = card.getAttribute("data-available") === "true";
        card.classList.toggle("is-hidden-by-stock", hideOutOfStock && !isAvailable);
      });
    }

    function sortCards(sortMode) {
      var cards = getCards();

      cards.sort(function (a, b) {
        var aCardNumber = parseCardNumber(a.getAttribute("data-card-number"));
        var bCardNumber = parseCardNumber(b.getAttribute("data-card-number"));

        var aPrice = parseInt(a.getAttribute("data-price") || "0", 10);
        var bPrice = parseInt(b.getAttribute("data-price") || "0", 10);

        var aDate = parseInt(a.getAttribute("data-created") || "0", 10);
        var bDate = parseInt(b.getAttribute("data-created") || "0", 10);

        var aOriginal = parseInt(a.getAttribute("data-original-index") || "0", 10);
        var bOriginal = parseInt(b.getAttribute("data-original-index") || "0", 10);

        if (sortMode === "card-number-desc") {
          return bCardNumber - aCardNumber || aOriginal - bOriginal;
        }

        if (sortMode === "price-asc") {
          return aPrice - bPrice || aOriginal - bOriginal;
        }

        if (sortMode === "price-desc") {
          return bPrice - aPrice || aOriginal - bOriginal;
        }

        if (sortMode === "date-desc") {
          return bDate - aDate || aOriginal - bOriginal;
        }

        if (sortMode === "date-asc") {
          return aDate - bDate || aOriginal - bOriginal;
        }

        return aCardNumber - bCardNumber || aOriginal - bOriginal;
      });

      cards.forEach(function (card) {
        grid.appendChild(card);
      });

      applyStockFilter();
    }

    if (sortSelect) {
      sortSelect.addEventListener("change", function () {
        sortCards(sortSelect.value);
      });
    }

    if (stockToggle) {
      stockToggle.addEventListener("change", applyStockFilter);
    }

    sortCards(sortSelect ? sortSelect.value : "card-number-asc");
    applyStockFilter();
  }

  function updateDisplayShelf(selectedGame) {
    var shelf = document.querySelector("[data-display-shelf]");
    if (!shelf) {
      return;
    }

    var shelfBinders = Array.prototype.slice.call(shelf.querySelectorAll(".bb-binder-card"));

    shelfBinders.forEach(function (binder) {
      var binderGame = binder.getAttribute("data-display-game");
      var shouldShow = binderGame === "all" || binderGame === selectedGame;
      binder.classList.toggle("is-visible", shouldShow);
    });
  }

  function updateSetBinderDropdown(shelf, selectedGame) {
    if (!shelf) {
      return;
    }

    var select = shelf.querySelector("[data-set-binder-select]");
    if (!select) {
      return;
    }

    var placeholder = select.querySelector("[data-set-binder-placeholder]");
    var options = Array.prototype.slice.call(select.querySelectorAll("option[data-set-game]"));
    var hasSelection = !!selectedGame;
    var visibleCount = 0;
    var selectableCount = 0;

    options.forEach(function (option) {
      var optionGame = option.getAttribute("data-set-game");
      var isComingSoon = option.getAttribute("data-coming-soon") === "true";
      var shouldShow = hasSelection && optionGame === selectedGame;

      option.hidden = !shouldShow;

      if (shouldShow) {
        visibleCount += 1;
      }

      if (shouldShow && !isComingSoon && option.value) {
        selectableCount += 1;
        option.disabled = false;
      } else {
        option.disabled = true;
      }
    });

    if (placeholder) {
      placeholder.hidden = false;
      placeholder.disabled = false;
      placeholder.textContent = hasSelection
        ? (visibleCount ? "Choose a set binder..." : "No set binders yet")
        : "Pick a game first";
    }

    select.value = "";
    select.disabled = !hasSelection || !visibleCount;

    shelf.classList.toggle("has-dropdown-options", hasSelection && visibleCount > 0);
    shelf.classList.toggle("has-selectable-dropdown-options", hasSelection && selectableCount > 0);
  }

  function updateSetShelf(selectedGame) {
    var shelf = document.querySelector("[data-set-shelf]");
    if (!shelf) {
      return;
    }

    var row = shelf.querySelector(".bb-set-binder-row");
    var setBinders = Array.prototype.slice.call(shelf.querySelectorAll(".bb-set-binder-card"));
    var hasSelection = !!selectedGame;

    shelf.classList.toggle("has-selection", hasSelection);

    setBinders.forEach(function (binder) {
      var binderGame = binder.getAttribute("data-set-game");
      var shouldShow = hasSelection && binderGame === selectedGame;
      binder.classList.toggle("is-visible", shouldShow);
    });

    updateSetBinderDropdown(shelf, selectedGame);

    if (row && hasSelection) {
      row.scrollTo({
        left: 0,
        behavior: "smooth"
      });
    }
  }

  function setupSetBinderSelect() {
    var shelves = Array.prototype.slice.call(document.querySelectorAll("[data-set-shelf]"));

    shelves.forEach(function (shelf) {
      var select = shelf.querySelector("[data-set-binder-select]");

      if (!select || select.dataset.setBinderSelectReady === "true") {
        return;
      }

      select.dataset.setBinderSelectReady = "true";

      select.addEventListener("change", function () {
        var selectedOption = select.options[select.selectedIndex];

        if (!selectedOption || !selectedOption.value) {
          select.value = "";
          return;
        }

        window.location.href = selectedOption.value;
      });
    });
  }

  function setupHorizontalScroll(root, rowSelector, prevSelector, nextSelector, readyKey) {
    if (!root || root.dataset[readyKey] === "true") {
      return;
    }

    root.dataset[readyKey] = "true";

    var row = root.querySelector(rowSelector);
    var prev = root.querySelector(prevSelector);
    var next = root.querySelector(nextSelector);

    if (!row || !prev || !next) {
      return;
    }

    function scrollAmount() {
      return Math.max(180, Math.round(row.clientWidth * 0.72));
    }

    prev.addEventListener("click", function () {
      row.scrollBy({
        left: -scrollAmount(),
        behavior: "smooth"
      });
    });

    next.addEventListener("click", function () {
      row.scrollBy({
        left: scrollAmount(),
        behavior: "smooth"
      });
    });
  }

  function setupShelfScroll() {
    var shelf = document.querySelector("[data-display-shelf]");

    setupHorizontalScroll(
      shelf,
      ".bb-binder-row",
      "[data-shelf-scroll-prev]",
      "[data-shelf-scroll-next]",
      "shelfScrollReady"
    );
  }

  function setupSetShelfScroll() {
    var shelf = document.querySelector("[data-set-shelf]");

    setupHorizontalScroll(
      shelf,
      ".bb-set-binder-row",
      "[data-set-scroll-prev]",
      "[data-set-scroll-next]",
      "setShelfScrollReady"
    );
  }

  function setupGameScroll(root) {
    setupHorizontalScroll(
      root,
      ".bb-game-grid",
      "[data-game-scroll-prev]",
      "[data-game-scroll-next]",
      "gameScrollReady"
    );
  }

  function setupBinderBrowser(root) {
    if (!root || root.dataset.binderBrowserReady === "true") {
      return;
    }

    root.dataset.binderBrowserReady = "true";

    var tiles = Array.prototype.slice.call(root.querySelectorAll(".bb-game-tile"));

    tiles.forEach(function (tile) {
      tile.addEventListener("click", function () {
        var selectedGame = tile.getAttribute("data-game");

        tiles.forEach(function (otherTile) {
          var isSelected = otherTile === tile;
          otherTile.classList.toggle("is-selected", isSelected);
          otherTile.setAttribute("aria-pressed", isSelected ? "true" : "false");
        });

        root.setAttribute("data-selected-game", selectedGame || "");

        updateDisplayShelf(selectedGame);
        updateSetShelf(selectedGame);
      });
    });

    setupGameScroll(root);
  }

  function init() {
    var roots = document.querySelectorAll("[data-binder-browser]");
    roots.forEach(setupBinderBrowser);

    setupShelfScroll();
    setupSetShelfScroll();
    setupSetBinderSelect();
    updateSetShelf("");
    setupBinderResultsControls();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (event && event.target) {
      var root = event.target.querySelector("[data-binder-browser]");
      if (root) {
        setupBinderBrowser(root);
      }

      if (event.target.querySelector("[data-display-shelf]")) {
        setupShelfScroll();
      }

      if (event.target.querySelector("[data-set-shelf]")) {
        setupSetShelfScroll();
        setupSetBinderSelect();
        updateSetShelf("");
      }

      if (event.target.querySelector("[data-binder-results]")) {
        setupBinderResultsControls();
      }
    }
  });
})();